import { UNITED_STATES_AND_CANADA_PHONE_CODE } from '../countries/index.js';
export const MOCK_PHONE = {
    countryCode: '1',
    number: '5551234567',
    extension: null,
};
/**
 * Formats a phone number for display with country code and extension
 * @param phone - Phone data object with countryCode, number, and extension
 * @returns Formatted phone number string or null if no number
 *
 * @example
 * ```ts
 * formatPhoneNumber({ countryCode: '1', number: '1234567890', extension: '123' })
 * // Returns "+1 (123) 456-7890 ext. 123"
 * ```
 *
 * @example
 * ```ts
 * formatPhoneNumber({ countryCode: '44', number: '1234567890', extension: null })
 * // Returns "+44 1234567890"
 * ```
 */
export function formatPhoneNumber(phone) {
    if (!phone || !phone.number) {
        return null;
    }
    const { countryCode, number, extension } = phone;
    // Format the base number with country code
    let formattedNumber;
    if (countryCode === UNITED_STATES_AND_CANADA_PHONE_CODE) {
        // Format US/Canada numbers as (XXX) XXX-XXXX
        formattedNumber = `(${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(6)}`;
    }
    else {
        // Format international numbers as +XX XXXXXXXXX
        formattedNumber = `+${countryCode} ${number}`;
    }
    // Add extension if present
    if (extension) {
        formattedNumber += ` ext. ${extension}`;
    }
    return formattedNumber;
}
